
import configureStore from '../store/store';

class Auth {

    static getInstance() {
        if (!(this.singleton instanceof this)) {
            this.singleton = new this();
        }
        return this.singleton;
    }

    skipStorageListener = false;

    getStore = () => configureStore();

    getTokenName = () => require('../constants/config').jwtTokenName;

    update = token => {
        return this.tokenIsExpired(token);
    };

    tokenIsExpired = (token) => {
        try {
            const decodedToken = this._decodeToken(token);

            const decodedDate = new Date(0);
            decodedDate.setUTCSeconds(decodedToken.exp);

            // we do not check the signature here because we do not want our SECRET on the client side
            return decodedDate < new Date();
        } catch (e) {
            console.error(e);
            return true;
        }
    };

    _decodeToken = (token = '..') => {
        const spl = token.split('.');
        const body = spl[1];

        if (!body)
            return this._getEmptyToken();

        try {
            const buff = new Buffer(body, 'base64');
            const jsonStr = buff.toString('ascii');

            return JSON.parse(jsonStr);
        } catch (e) {
            // console.log('error in decoding token', e);
            return this._getEmptyToken();
        }
    };

    _getEmptyToken = () => {
        return {orgId: null, exp: null}
    };

    _setToken = (token) => {
        this.skipStorageListener = true;
        localStorage.setItem(this.getTokenName(), token);
    };

    _getToken = () => {
        const token = localStorage.getItem(this.getTokenName());;
        if(!this.tokenIsExpired(token))
            return token;
        return null;
    }

    _getDecodedToken = () => {
        const token = localStorage.getItem(this.getTokenName());
        if(!this.tokenIsExpired(token)){
            const decoded = this._decodeToken(token);
            return decoded;
        }
        return null;
    };

    processJWT = (jwtString, dispatch) => {
        const isCorrect = !this.tokenIsExpired(jwtString);
        if(isCorrect) {
            this._setToken(jwtString);
            dispatch({type: 'LOGIN', payload: {token: jwtString}});
        }
        return isCorrect;
    }
}

export default Auth;



// WEBPACK FOOTER //
// ./src/util/auth.js